import React, { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react';
import ReactCrop from 'react-image-crop';
import Axios from '../../AxiosConfig';
import Loader from './loader';


function ImageCropingViewer(props) {
    const {
        src,
        setCropingOpen,
        open,
        realProfile,
        mainUuid,
        category,
        setEmployeeImage,
    } = props;

    const cancelButtonRef = useRef(null);
    const [image, setImage] = useState(null);
    const [crop, setCrop] = useState({
        unit: 'px', // Can be 'px' or '%'
        x: 0,
        y: 0,
        width: 100,
        height: 100,
    })
    const [loading, setLoading] = useState(false);


    const cropImageNow = async () => {
        if (image && realProfile && mainUuid && category) {
            setLoading(true)
            const data = new FormData();
            for (let i = 0; i < realProfile.length; i++) {
                data.append("files", realProfile[i]);
            }

            let myImg = document.querySelector("#imgId");
            let realWidth = myImg.naturalWidth;
            let realHeight = myImg.naturalHeight;

            data.append("doCrop", "doCrop");
            data.append("crop.x", crop.x);
            data.append("crop.y", crop.y);
            data.append("crop.width", crop.width);
            data.append("crop.height", crop.height);
            data.append("naturalWidth", realWidth);
            data.append("naturalHeight", realHeight);

            data.append("uuid", mainUuid);
            data.append("category", category);
            try {
                const res = await Axios({
                    method: "POST",
                    url: "/upload-profile-image",
                    data: data,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (res.data.success)
                    console.log(res.data, "res.data")
                setEmployeeImage(res.data.files);
                setCropingOpen(false);
                setLoading(false)
                return {
                    category,
                    files: res.data.files,
                }
            } catch (error) {
                setLoading(false)
                return {
                    category,
                    files: [],
                }
            }
        }
    };

    return (
        <>
            {loading && <Loader />}
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setCropingOpen}>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>


                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="file-viewer-modal relative transform overflow-scroll rounded-lg bg-white pt-2 px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-5xl h-10 sm:p-6">
                                    <div class="flex items-center justify-between mb-2 md:mb-2 border-b rounded-t dark:border-gray-600">
                                        <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                                            Crop the Image
                                        </h3>
                                        <button onClick={() => setCropingOpen(false)} type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="default-modal">
                                            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                            </svg>
                                            <span class="sr-only">Close modal</span>
                                        </button>
                                    </div>
                                    <div className='flex'>
                                        <div className='flex flex-col justify-center align-center'>
                                            <ReactCrop crop={crop}
                                                onChange={c => setCrop(c)}
                                                aspect={1 / 1}>
                                                <img
                                                    src={src}
                                                    id='imgId'
                                                    onLoad={setImage}
                                                    alt="croping"
                                                />
                                            </ReactCrop>
                                            <button
                                                type="button"
                                                onClick={cropImageNow}
                                                className="inline-flex ml-auto justify-center py-2 px-4 m-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                            >
                                                Done
                                            </button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    )
}

export default ImageCropingViewer;